import type { SVGProps } from "react";
import * as React from "react";

export const StopIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className="fill-current"
    {...props}
  >
    <circle
      cx={9}
      cy={9}
      r={8.053}
      stroke="currentColor"
      strokeWidth={1.895}
    />
    <path
      stroke="currentColor"
      strokeWidth={2}
      d="M15 3 3 15"
    />
  </svg>
);
